// filepath: src/components/date-picker/styles.ts
import styled from "styled-components";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import theme from "../../../../styles/theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: "Roboto", sans-serif;
  width: 100%;
`;

export const Label = styled.label`
  font-size: 16px;
  color: #5f6368;
`;

export const StyledDatePicker = styled(DatePicker)`
  .MuiOutlinedInput-root {
    font-family: "Roboto", sans-serif;
    height: 48px;
    border-radius: 24px;
    background-color: #ffffff;
    transition: border-color 0.2s ease;

    & .MuiOutlinedInput-notchedOutline {
      border-color: #dadce0;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: #5f6368;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-width: 2px;
      border-color: ${theme.colors.blue.primary};
    }
  }

  .MuiInputBase-input {
    padding: 0 14px;
    &::placeholder {
      color: #9ca3af;
      opacity: 1;
    }
  }

  .MuiButtonBase-root {
    color: #5f6368;
  }
`;
